module.exports = __webpack_public_path__ + "media/country_flags/gp-d1c3f36d.png";